import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
    SetProfile = '[PROFILE_ACT] SET_PROFILE',
    SetLogin = '[PROFILE_ACT] SET_LOGIN',
    SetLogout = '[PROFILE_ACT] SET_LOGOUT',
    SetNotiBadge = '[PROFILE_ACT] SET_NOTI_BADGE',
}

export const SetProfile = createAction(
    ActionTypes.SetProfile, //action name
    props<{ profileInfo: ProfileType }>() //parameter
);

export const SetNotiBadge = createAction(
    ActionTypes.SetNotiBadge,
    props<{ badge: number }>()
);

export const SetLogin = createAction(
    ActionTypes.SetLogin,
    props<{ data: ProfileInfoType }>()
);

export const SetLogout = createAction(ActionTypes.SetLogout);
